import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { AnalyticsService } from './analytics.service';
import { RotasApp } from '@shared/utils/constants/rotas.enum';
import { Store } from '@ngrx/store';
import { salvarDadosToken } from '@shared/store/actions/token.actions';

@Injectable({
  providedIn: 'root',
})
export class AutenticarService {
  whiteList: string;
  constructor(
    private tokenService: TokenService,
    private analyticsService: AnalyticsService,
    private store: Store<any>
  ) {}

  async init(urlParams: URLSearchParams, rota: string) {
    return new Promise(async (resolve) => {
      let tokenId: string;

      if (rota.includes(`${RotasApp.CALLBACK}`)) {
        tokenId = 'PIS';
      } else {
        if (urlParams.get('id_token')) {
          tokenId = urlParams.get('id_token');
        }

        if (urlParams.get('id_receptora')) {
          tokenId = urlParams.get('id_receptora');
        }
      }

      const retornoToken = await this.tokenService.getTokenIdPermanente(tokenId).toPromise();

      if (rota.includes(`${RotasApp.TRANSMISSORA}`) || rota.includes(`${RotasApp.CALLBACK}`)) {
        resolve(true);
        return;
      }

      const retornoTokenDados = await this.tokenService.getTokenDados(retornoToken.data.tokenId).toPromise();

      this.analyticsService.setUserId(retornoTokenDados.idBiocatch);
      this.analyticsService.setIdUnico(retornoTokenDados.idUnico);
      this.whiteList = retornoTokenDados.whitelist ? retornoTokenDados.whitelist : null;
      this.store.dispatch(salvarDadosToken({ dadosToken: retornoTokenDados }));
      resolve(true);
    });
  }

  getWhiteList(): string {
    return this.whiteList;
  }
}
